import { Typography } from 'src/typography';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const FooterContainer = styled.div<{
  $containerOverrides?: FlattenSimpleInterpolation;
  $borderOverrides?: FlattenSimpleInterpolation;
}>`
  position: relative;
  background: transparent;
  padding-top: ${({ theme }) => theme.spaces[5]};
  width: 100%;
  order: 99;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-top: 1px solid ${({ theme }) => theme.colors.white};
    ${({ $borderOverrides }) => $borderOverrides}
  }

  ${({ $containerOverrides }) => $containerOverrides}

  /* Smooth slide-down entrance */
  animation: slideDownFade 0.4s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes slideDownFade {
    0% {
      max-height: 0;
      opacity: 0;
      padding-top: 0;
      margin-bottom: 0;
    }
    100% {
      max-height: 100px;
      opacity: 1;
      padding-top: ${({ theme }) => theme.spaces[5]};
      margin-bottom: 0;
    }
  }
`;

export const DesktopLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme: { spaces } }) => spaces[4]};
`;

export const MobileLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme: { spaces } }) => spaces[3]};
`;

export const TextContent = styled(Typography.Body).attrs({
  size: 'medium',
})`
  flex: 1 0 0;
  font-weight: 600;
  line-height: 1.2;
`;

export const ButtonWrapper = styled.div`
  flex-shrink: 0;
`;
